var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgManualImport = function SvgManualImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.946 15.851c.295 0 .54.216.586.498l.008.097v1.98a2.577 2.577 0 0 1-2.412 2.569l-.163.005h-9.9a2.577 2.577 0 0 1-2.57-2.412l-.005-.162v-1.98a.594.594 0 0 1 1.18-.097l.008.097v1.98c.001.72.55 1.312 1.253 1.38l.133.006h9.901c.72 0 1.312-.55 1.38-1.253l.006-.133v-1.98c0-.329.266-.595.595-.595zM16.956 1a2.577 2.577 0 0 1 2.568 2.412l.006.162v2.97a2.577 2.577 0 0 1-2.412 2.57l-.163.005H11.61v5.892l2.947-2.947a.594.594 0 0 1 .663-.112l.089.051.081.068c.204.204.23.52.073.751l-.067.083-3.96 3.96a.594.594 0 0 1-.769.061l-.071-.06-3.962-3.962a.594.594 0 0 1 .759-.906l.082.067 2.947 2.947V9.119H5.074a2.577 2.577 0 0 1-2.553-2.245l-.016-.167-.005-.162v-2.97a2.577 2.577 0 0 1 2.412-2.57L5.074 1h11.882zm0 1.188H5.073c-.72 0-1.312.55-1.38 1.253l-.006.133v2.97c0 .72.55 1.312 1.253 1.38l.133.007h11.881a1.389 1.389 0 0 0 1.38-1.253l.007-.133v-2.97a1.388 1.388 0 0 0-1.387-1.387z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgManualImport;